import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../environment/environment';
import { AuthService } from '../auth/auth.service';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  private messageSource = new BehaviorSubject<any>(null);
  currentMessage = this.messageSource.asObservable();

  constructor(
    private http: HttpService,
    private authService: AuthService,
    private messaging: Messaging
  ) {}

  init(): void {
    this.requestPermission()
      .pipe(
        switchMap(() => this.updateToken()),
        catchError((error) => {
          console.error('FCM initialization error:', error);
          throw error;
        })
      )
      .subscribe();

    onMessage(this.messaging, (message) => {
      this.messageSource.next(message);
    });
  }

  requestPermission(): Observable<string> {
    return from(
      getToken(this.messaging, { vapidKey: environment.firebase.vapidKey })
    ).pipe(
      tap((token) => {
        if (!token) {
          console.warn('FCM Permission denied or no token available');
        }
      }),
      catchError((error) => {
        console.error('Unable to get permission for FCM:', error);
        throw error;
      })
    );
  }

  updateToken(): Observable<any> {
    if (!this.authService.isAuthenticated()) {
      return new Observable((observer) => {
        observer.complete();
      });
    }

    return from(
      getToken(this.messaging, { vapidKey: environment.firebase.vapidKey })
    ).pipe(
      switchMap((token) => {
        if (!token) {
          throw new Error('No FCM token available');
        }
        return this.http.post(`${environment.apiUrl}/user/fcm-token`, {
          fcmToken: token,
        });
      }),
      catchError((error) => {
        console.error('Error updating FCM token:', error);
        throw error;
      })
    );
  }

  getToken(): Observable<string> {
    return from(
      getToken(this.messaging, { vapidKey: environment.firebase.vapidKey })
    );
  }

  getMessages(): Observable<any> {
    return this.currentMessage;
  }
}
